module.exports = __webpack_public_path__ + "img/销售商城.8e31acd6.svg";